import { render } from "./RatingStars.vue?vue&type=template&id=b74bf866&scoped=true&ts=true"
import script from "./RatingStars.vue?vue&type=script&lang=ts"
export * from "./RatingStars.vue?vue&type=script&lang=ts"

import "./RatingStars.vue?vue&type=style&index=0&id=b74bf866&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b74bf866"]])

export default __exports__